import HeaderAccountBtn from "./HeaderAccountBtn";
import HeaderUnReadBell from "./HeaderUnReadBell";
import HeaderUser from "./HeaderUser";
import { NavigationHeaderContext } from "./NavigationHeaderContext";
import { login } from "../utils";
import { Space } from 'antd';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
var HeaderLogin = function HeaderLogin() {
  var NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  var rightMenu = NavigationHeaderContextProps.rightMenu,
    uid = NavigationHeaderContextProps.uid,
    env = NavigationHeaderContextProps.env,
    onLogin = NavigationHeaderContextProps.onLogin;
  var defaultMenu = {
    user: /*#__PURE__*/React.createElement(HeaderUser, {
      key: "user"
    }),
    bell: /*#__PURE__*/React.createElement(HeaderUnReadBell, {
      key: "bell"
    }),
    account: /*#__PURE__*/React.createElement(HeaderAccountBtn, {
      key: "account"
    })
  };
  var renderRightMenu = function renderRightMenu() {
    if (Array.isArray(rightMenu)) {
      return rightMenu.map(function (item) {
        if (typeof item === 'string') {
          if (['user', 'bell', 'account'].includes(item)) {
            return defaultMenu[item];
          }
          return null;
        }
        if ( /*#__PURE__*/React.isValidElement(item)) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, item);
        }
        return null;
      });
    }
    return ['user', 'bell', 'account'].map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: "default_".concat(item)
      }, defaultMenu[item]);
    });
  };
  return /*#__PURE__*/React.createElement("div", null, uid ? /*#__PURE__*/React.createElement(Space, {
    size: 24
  }, renderRightMenu()) : /*#__PURE__*/React.createElement("div", {
    className: "dr-nav-login-btn",
    onClick: function onClick() {
      if (onLogin) {
        onLogin();
      } else {
        login({
          env: env
        });
      }
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "login"
  })));
};
export default HeaderLogin;